export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-2xl bg-foreground-950 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="w-full h-64 lg:h-full min-h-[320px] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20modern%20portrait%20concept%20with%20soft%20warm%20tones%2C%20cream%20and%20beige%20gradient%20background%2C%20editorial%20fashion%20photography%20style%2C%20confident%20contemporary%20atmosphere%2C%20minimal%20composition%20with%20elegant%20shadow%20play%2C%20sophisticated%20lifestyle%20aesthetic&width=800&height=900&seq=testimonial-portrait-v3&orientation=portrait"
                  alt="Verified buyer review"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center p-8 md:p-12 lg:p-16">
              <div className="text-accent-400 text-7xl md:text-8xl font-serif leading-none mb-6 opacity-60">
                &ldquo;
              </div>
              <blockquote className="text-white/90 text-lg md:text-xl leading-relaxed mb-8">
                The AllChinaBuy Spreadsheet completely changed how I shop internationally. Before finding this resource, I wasted hours searching for reliable sellers and comparing prices. Now I can find exactly what I need in minutes — the verification system gives me confidence that every seller I choose is trustworthy. I have placed over 30 orders using sellers from the spreadsheet and every single one arrived as described.
              </blockquote>
              <div className="mb-6">
                <div className="text-white font-semibold text-sm">Marcus Chen</div>
                <div className="text-white/50 text-xs mt-1">International Buyer &bull; 30+ Orders Completed</div>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-accent-500 text-foreground-950 font-semibold text-sm hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap w-fit"
              >
                Start Shopping Now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}